<div class="search-wrapper">
  <mat-icon class="search-icon" matPrefix>search</mat-icon>
  <mat-form-field class="search-input flex-1" mat-input-height-small>
    <mat-label>{{ '+SEARCH.SEARCH_FIELDS.TITLE' | translate }}</mat-label>
    <input
      matInput
      type="text"
      [(ngModel)]="searchTerm"
      [readonly]="disabled"
      data-at-installation-search
      gtm="onTextField"
      gtmId="search-term"
      gtmAction="Search term"
      [gtmCategory]="categoryForGtm || 'Overview'"
      [gtmOn]="['change', 'focus', 'blur']"
      fieldTextContentTooltip
    />
    <button
      *ngIf="searchTerm"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="Search installations input"
      [gtmCategory]="categoryForGtm || 'Overview'"
      (click)="clearSearch()"
      data-at-clear-search-button
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
